import React from 'react';
import css from './GetStartedSection.module.css';
import createBriefLogo from '../../../../assets/Create-your-project-Brief-logo.svg';
import estimateCostsLogo from '../../../../assets/Estimate-your-build-costs-logo.svg';
import supplierQuotesLogo from '../../../../assets/Plan-for-supplier-qoutes-logo.svg';

const CARDS = [
  {
    logo: createBriefLogo,
    title: 'Create Your Project Brief',
    description: 'Outline your vision & requirements',
  },
  {
    logo: estimateCostsLogo,
    title: 'Estimate Your Build Costs',
    description: 'Get early cost guidance based on real project data',
  },
  {
    logo: supplierQuotesLogo,
    title: 'Plan for Supplier Quotes',
    description: 'Get matched with vetted suppliers and request pricing early',
  },
];

const GetStartedSection = () => {
  return (
    <section className={css.section}>
      <div className={css.inner}>
        <h2 className={css.heading}>Get started right away</h2>
        <p className={css.subtext}>Prepare your build while we activate your planning</p>

        <div className={css.cardsRow}>
          {CARDS.map(({ logo, title, description }) => (
            <div key={title} className={css.card}>
              <div className={css.iconWrap}>
                <img src={logo} alt={title} className={css.icon} />
              </div>
              <h3 className={css.cardTitle}>{title}</h3>
              <p className={css.cardDesc}>{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GetStartedSection;
